export default __webpack_public_path__ + "static/media/Christo_Viljoen.41a9745c.jpeg";